/**
 * ProtectedRoute
 * ==============
 * Auth + onboarding gate used across the AADHYAA app.
 *
 *   - If the AuthContext is still loading, show a centered spinner.
 *   - If no user, redirect to /auth.
 *   - If user has not completed onboarding (no birth_chart on file),
 *     redirect to /onboarding — unless requireOnboarding=false (used for
 *     the onboarding flow itself + a few preference pages).
 *
 * Extracted from App.js as part of the 19.2 maintainability sprint.
 */
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, requireOnboarding = true }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-screen page-background flex items-center justify-center"
        data-testid="protected-route-loading"
      >
        <div className="text-center">
          <div className="w-12 h-12 border-2 border-[var(--primary)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-[var(--text-muted)]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // P0 Fix: enforce onboarding completion before accessing the main app
  const hasCompletedOnboarding = Boolean(
    user.has_birth_chart ||
    user.birth_date ||
    (user.birth_data && user.birth_data.birth_date)
  );

  if (requireOnboarding && !hasCompletedOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default ProtectedRoute;
